import { GlobeIcon, PhoneIcon, SendIcon, UserRoundIcon, type LucideIcon } from 'lucide-react';

import type { ChannelType } from '../types';

/** The icon of a channel (no brand marks: a globe for the site, a paper plane for Telegram, a phone for Viber). */
export const CHANNEL_ICON: Record<ChannelType, LucideIcon> = {
  widget: GlobeIcon,
  'telegram-bot': SendIcon,
  'telegram-user': UserRoundIcon,
  'viber-bot': PhoneIcon,
};
